import React, { useRef, useState, useEffect } from "react";
import styles from "./sliderButton.module.scss";

const SliderButton = ({ onComplete, label = "Initiate SOS" }) => {
  const sliderRef = useRef(null);

  const [offsetX, setOffsetX] = useState(0);
  const [sliding, setSliding] = useState(false);
  const [state, setState] = useState("idle");

  const start = () => {
    if (state === "done") return;
    setSliding(true);
    setState("sliding");
  };

  const finish = () => {
    if (!sliding) return;

    const width = sliderRef.current.offsetWidth;
    if (offsetX > width * 0.65) {
      setState("done");
      setOffsetX(width - 50);
      onComplete && onComplete();
    } else {
      setState("idle");
      setOffsetX(0);
    }

    setSliding(false);
  };

  const move = clientX => {
    if (!sliding || state === "done") return;

    const rect = sliderRef.current.getBoundingClientRect();
    let x = clientX - rect.left;
    const max = rect.width - 50;

    if (x < 0) x = 0;
    if (x > max) x = max;

    setOffsetX(x);
  };

  // Attach global listeners when sliding
  useEffect(() => {
    const handleMove = e => {
      const x =
        e.clientX !== undefined
          ? e.clientX
          : e.touches && e.touches[0] && e.touches[0].clientX;

      move(x);
    };

    const handleUp = () => finish();

    if (sliding) {
      window.addEventListener("mousemove", handleMove);
      window.addEventListener("mouseup", handleUp);
      window.addEventListener("touchmove", handleMove);
      window.addEventListener("touchend", handleUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMove);
      window.removeEventListener("mouseup", handleUp);
      window.removeEventListener("touchmove", handleMove);
      window.removeEventListener("touchend", handleUp);
    };
  }, [sliding, offsetX]);

  // useEffect(() => {
  //   console.log("STATE:", state);
  // }, [state]);

  return (
    <div className={`${styles.sliderWrapper} ${styles[state]}`} ref={sliderRef}>
      <div className={styles.sliderLabel}>
        {state === "done" ? "Done" : state === "idle" ? label : ""}
      </div>

      <div
        className={styles.sliderKnob}
        onMouseDown={start}
        onTouchStart={start}
        style={{ transform: `translateX(${offsetX}px)` }}
      >
        <img
          src={
            state === "done"
              ? "https://d1flzashw70bti.cloudfront.net/original/images/slider/done.svg"
              : "https://d1flzashw70bti.cloudfront.net/original/images/slider/idle.svg"
          }
          alt="slider icon"
        />
      </div>
    </div>
  );
};

export default SliderButton;
